import { render, staticRenderFns } from "./TemplateModels.vue?vue&type=template&id=7c230028&"
import script from "./TemplateModels.vue?vue&type=script&lang=js&"
export * from "./TemplateModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports